"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'modal.share.title': 'Share Content',
};
